import React from 'react';
import "./style.css";
import { ButtonLarge } from "../ButtonLarge";


export const JobPosts = ({jobsData}) => {

	const jobPage = (jobsData)? jobsData.slice(0,7) :[];

	const convertDate = (date) => { 
		const ndate = new Date(date);
		return ndate.toDateString();
	}

	const cleanDescription = (desc) => {
		const stripHTMLTags = desc.replace(/<[^>]+>/g, '');
		const arrDesc = stripHTMLTags.split(" ");

		return arrDesc.filter(n => n).slice(0, 50).join(" ");
	}

	const jobdivaPortal = "https://www1.jobdiva.com/portal/?a=c2jdnwjac9w0nu3t6yqt2rnyuleo6h0a78q6oyfale15zx3igfn33qj7kni52v2a"

  	return (
		<div className="jobs-segment">
			{
				//<div className="tab">
				
				 //<div className="filter">
				  //	<ButtonSmall buttonSmall="active" text="All" />
				  //	<ButtonSmall buttonSmall="secondary" text="On-site" />
				  //	<ButtonSmall buttonSmall="secondary" text="Hybrid" />
				//	<ButtonSmall buttonSmall="secondary" text="Remote" />
				//</div> 
				
			//</div>
			}
			<div className="roleParent">
				{
					jobPage.map(job => {
						return(
							<div className="role" key={job.jobID}>
								<div className="role-layer">
									<div className="role-content">
										<div className="roleTitle">{(job["POSTING_TITLE"])? job.POSTING_TITLE : job.JOBTITLE}</div>
										<div className="roleText">{cleanDescription(job.POSTINGDESCRIPTION)}...</div>
										<div className="role-specs">
											<div className="role-spec">Posted: {convertDate(job.DATEISSUED)}</div>
											<div className="role-spec">{(job["POSTING_CITY"])? job.POSTING_CITY: "Remote"}{(job["POSTING_STATE"])? ", " + job.POSTING_STATE: ""}</div>
											<div className="role-spec">#{job.REFNO}</div>
										</div>
									</div>
									<div className="buttonSmallWrapper">
										<ButtonLarge className="button-large-black" text="See details" linkTo={jobdivaPortal + '#/jobs/' + job.jobID } target="_blank"  />
									</div>
								</div>
							</div>
						)
					})
				}
				
			</div>
			<div className="buttonSmallParent">
				<ButtonLarge className="button-large-black" text="View More" linkTo={jobdivaPortal} target="_blank"  />
			</div>
		</div>
		);                            																		
};
                                    																		